import { IonRouterOutlet, useIonRouter } from '@ionic/react';
import React from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';

import RoutePath from '@custom-types/RoutePath';
import { generateRoute } from '@services/navigation-service';

import { Print } from './Print';
import { PrintBadgeTabs } from './Tabs';

// This is needed because there is a bug in our version of Ionic or React-Router that causes
// top-level routes to not unmount correctly. Adding a second IonRouterOutlet fixes this.
export const PrintBadge = ({ match: rootMatch }: RouteComponentProps) => {
  const router = useIonRouter();
  const dismiss = () => router.goBack();
  return (
    <IonRouterOutlet>
      <Route exact path={rootMatch.url}>
        <Redirect to={`${rootMatch.url}/scanner`} />
      </Route>
      <Route
        path={[
          generateRoute(RoutePath.PrintBadgeScanner),
          generateRoute(RoutePath.PrintBadgeSearch),
        ]}
      >
        <PrintBadgeTabs />
      </Route>
      <Route
        path={generateRoute(RoutePath.PrintBadgeFlow)}
        render={({ match }) => (
          <Print
            checkInCode={match.params.checkInCode}
            shouldCheckIn={!!match.params.shouldCheckIn && match.params.shouldCheckIn !== 'false'}
            dismiss={dismiss}
          />
        )}
      />
      <Route path={generateRoute(RoutePath.PrintBadgeTest)}>
        <Print checkInCode="" testPrint dismiss={dismiss} />
      </Route>
    </IonRouterOutlet>
  );
};
